module.exports = __webpack_public_path__ + "static/flight-3b-e02905f2a8ffec1a9f5e7b45b0ee6bcd.svg";